<template>
  <div class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center" style="z-index:999999;">
    <div class="fixed inset-0 transition-opacity" @click="$emit('close')">
      <div class="absolute inset-0 bg-black opacity-75"></div>
    </div>
    <div class="bg-white shadow-xl transform transition-all sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-4 sm:pb-4">
        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
          <button type="button" class="text-gray-500 hover:text-gray-600 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150" aria-label="Close" @click="$emit('close')">
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="sm:flex sm:items-start border-b border-gray-400">
          <div class="mt-3 text-center sm:mt-0 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-black pb-2" id="modal-headline">
              Copy Members
            </h3>
          </div>
        </div>
        <div class="mt-4 text-sm">
          <p class="text-gray-700 mb-4">Select a form to copy its selected members onto this form.</p>
          <input-select
            label="Application Form"
            name="source_form"
            placeholder="Select a form"
            :options="formOptions"
            v-model="sourceFormId"
            :disabled="loadingForms"
            :required="false"/>
          <label v-if="selectedForm && selectedForm.qr_code" class="mt-4 flex items-center text-gray-800">
            <input type="checkbox" class="mr-2" v-model="scannedOnly"/>
            Only members who have scanned in
          </label>
          <p v-if="errorMessage" class="mt-3 text-red-700">{{ errorMessage }}</p>
        </div>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:px-4 sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button type="button"
            class="inline-flex justify-center w-full border border-transparent px-4 py-2 bg-default-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-default-700 focus:outline-none focus:border-default-700 transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50"
            :disabled="!sourceFormId || copying"
            @click="copyMembers">
            {{ copying ? 'Copying...' : 'Copy Members' }}
          </button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button type="button"
            class="inline-flex justify-center w-full border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            @click="$emit('close')">
            Cancel
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CopyMembersModal',
  props: {
    excludeId: { required: false, default: null }
  },
  data() {
    return {
      forms: [],
      sourceFormId: null,
      scannedOnly: false,
      loadingForms: true,
      copying: false,
      errorMessage: ''
    }
  },
  computed: {
    formOptions() {
      return this.forms
        .filter(form => String(form.id) !== String(this.excludeId))
        .map(form => ({ label: form.name, value: form.id }))
    },
    selectedForm() {
      return this.forms.find(form => String(form.id) === String(this.sourceFormId)) || null
    }
  },
  watch: {
    sourceFormId() {
      this.scannedOnly = false
      this.errorMessage = ''
    }
  },
  mounted() {
    document.body.classList.add('overflow-hidden')
    this.loadForms()
  },
  beforeDestroy() {
    document.body.classList.remove('overflow-hidden')
  },
  methods: {
    loadForms() {
      this.loadingForms = true

      axios.get(process.env.VUE_APP_API_URL + '/application-forms/member-sources')
        .then(response => {
          this.forms = response.data
        })
        .catch(() => {
          this.errorMessage = 'Unable to load application forms.'
        })
        .finally(() => {
          this.loadingForms = false
        })
    },
    copyMembers() {
      if (!this.sourceFormId || this.copying) {
        return
      }

      this.copying = true
      this.errorMessage = ''

      const scannedOnly = !!(this.selectedForm && this.selectedForm.qr_code && this.scannedOnly)

      axios.get(process.env.VUE_APP_API_URL + '/application-forms/' + this.sourceFormId + '/assigned-members', {
        params: {
          scanned_only: scannedOnly ? 1 : 0
        }
      }).then(response => {
        const memberIds = response.data.member_ids || []

        if (memberIds.length === 0) {
          this.errorMessage = scannedOnly
            ? 'No members have scanned in on that form.'
            : 'That form has no members selected to copy.'
          return
        }

        this.$emit('copied', memberIds)
      }).catch(() => {
        this.errorMessage = 'Unable to copy members from that form.'
      }).finally(() => {
        this.copying = false
      })
    }
  }
}
</script>
